<template>
    <div>
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_left">
                    <router-link :to="{ name: 'dailyCheckMenuSnapIndex'} ">戻る</router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s">{{title}}</p>
                    <p class="menu_center_tex_l">フリーコメント</p>
                </div>
            </div>
        </div>
        <div class="main_unit">
            <div class="prev_box">
                <router-link v-if="pageNo > 0" :to="{ name: 'dailyCheckMenuInputSnap',
                        params:{ menuId: menuId, subMenuId: subMenuId, page: pageNo }}">
                    <i class="fas fa-chevron-left prev_next_icn"></i><br>前</router-link>
            </div>
            <div class="top_unit">
                <div class="top_name_box">{{getStaffName}}</div>
            </div>
            <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
            <div v-show="!isInitLoading">
                <div class="w840_unit" >
                    <div class="wd840 mgt_20">
                        <textarea class="texbox_h475" placeholder="コメントを入力" v-model="freeComment" maxlength="400"></textarea>
                    </div>
                    <div class="btn_submit letter_spa">
                        <a role="button">登録</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    export default {
        name: 'DailyCheckFreeCommentSnap',
        components: {
            PulseLoader,
        },
        computed: {
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
            getStaffName: function () {
                return this.$store.getters['staff/data'].staffName;
            },
            menuNameUpper: function () {
                const button = this.$store.getters['buttons/topButton'](this.menuId)
                return 'upperButtonName' in button ? button.upperButtonName : ''
            },
            menuNameLower: function () {
                const button = this.$store.getters['buttons/topButton'](this.menuId)
                return 'lowerButtonName' in button ? button.lowerButtonName : ''
            },
            title: function () {
                const button = this.$store.getters['buttons/dailyCheckButton'](this.menuId, this.subMenuId)
                return 'dailyCheckButtonName' in button ? button.dailyCheckButtonName : ''
            },
        },
        props: {
            menuId: Number,
            subMenuId: Number,
        },
        data() {
            return {
                isInitLoading: true,
                freeComment: '',
                dailyCheckComments: null,
                pageNo: 0,
            }
        },
        created: function () {
            this.calc();
        },
        methods: {
            async calc() {
                this.isInitLoading = true;

                var brandId = this.$store.getters['brand/id'];
                var topButtonId = this.subMenuId;
                var storeId = this.$store.getters['store/data'].store_id;
                var datetime = this.dateFormat();
                var url = this.$apiEndpoint + 'user/brand/' + brandId + '/daily_menu/' + topButtonId + '/store/' + storeId + '?datetime=' + datetime;

                await this.$axios
                    .get(url)
                    .then(response => (
                        this.pageNo = response.data.dailyCheckContentsList.totalPage - 1
                        )
                    )
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params: {brandPath: this.$route.params.brandPath}}
                            }
                        }
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(() => this.isInitLoading = false);

                // エラーメッセージ及びコメント入力内容を初期化
                this.freeComment = '';

            },
            dateFormat() {
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = ("0" + (nowDate.getMonth() + 1)).slice(-2);
                let day = ("0" + nowDate.getDate()).slice(-2);
                let hours = ("0" + nowDate.getHours()).slice(-2);
                let minutes = ("0" + nowDate.getMinutes()).slice(-2);
                let seconds = ("0" + nowDate.getSeconds()).slice(-2);

                let format_str = 'YYYYMMDDhhmmss'
                format_str = format_str.replace(/YYYY/g, year);
                format_str = format_str.replace(/MM/g, month);
                format_str = format_str.replace(/DD/g, day);
                format_str = format_str.replace(/hh/g, hours);
                format_str = format_str.replace(/mm/g, minutes);
                format_str = format_str.replace(/ss/g, seconds);
                return format_str;
            },
        }
    }
</script>
